/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DownloadOutlined, MoreOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Space, Input, Menu, Dropdown, message } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { selectCurrentUser } from 'Store/user/selector'
import { formatDateTime, mapWordingStockMovementReport, numberWithComma } from 'helpers/format'
import { LoadingView } from 'Components/modal'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import BannerDetail from './detail'
import { Pagination } from 'Components/Pagination'
import PointAdjustment from './components/PointAdjustment'
import PointHistory from './components/PointHistory'
import PointReward from './components/PointReward'
import { APIPath } from 'services/APIPath'
import Axios from 'axios'
import downloadCSVFile from 'helpers/export'
import { appConfig } from 'config'
import { MemberData, MemberListReq } from 'Store/member-point/types'
import { getMemberListAPI } from 'Store/member-point/api'
import { selectMemberList } from 'Store/member-point/selector'
import { getStaffPermission } from 'helpers/account'
import { TutorialMemberPoint } from 'helpers/tutorials'
import { AppTutorial } from 'Components/utilities'

type Props = {} & ReduxProps

const PointMember: React.FunctionComponent<Props> = props => {
  const { currentUser, list } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [pointAdjustDrawer, setPointAdjustDrawer] = useState(false)
  const [historydrawer, setHistoryDrawer] = useState(false)
  const [rewardDrawer, setRewardDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [selectedCustomer, setSelectedCustomer] = useState(undefined as MemberData | undefined)
  const [exporting, setExporting] = useState(false)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')
  const listEvent = list?.event
  const permission = getStaffPermission()
  const canUpdateMember = permission && permission.includes('update-member')
  const canUpdateMemberPoint = permission && permission.includes('update-member-point')
  const canRedeemPoint = permission && permission.includes('member-redeem')
  const canSeeHistory = permission && permission.includes('member-history')
  // tutorial
  const [showTutorial, setShowTutorial] = useState(false as boolean)
  const steps = TutorialMemberPoint.memberList.steps
  const enableTutorial = TutorialMemberPoint.memberList.enable

  const [filter, setFilter] = useState({
    keyword: '',
    type: '',
    start_date: '',
    end_date: '',
    order_by: 'updated_at',
    sort: 'desc',
    customer_type: '',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = list.meta
  const datas = list.data

  const onGetList = (): void => {
    const req: MemberListReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      keyword: filter.keyword,
      order_by: filter.order_by,
      sort: filter.sort,
    }
    dispatch(getMemberListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onExport = (): void => {
    setExporting(true)
    const req: MemberListReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      keyword: filter.keyword,
      order_by: filter.order_by,
      sort: filter.sort,
      all: true,
    }
    const endPoint = appConfig.backofficeEndpoint + `${APIPath.getMemberList}?export=true`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || '',
        'x-auth-mid': currentUser?.activeMerchant?.id || 0,
      },
    }
    Axios.post(endPoint, req, header)
      .then((res: any) => {
        const reportData = mapWordingStockMovementReport(res.data)
        const fileName = `รายงานข้อมูลสมาชิก`
        downloadCSVFile(reportData, fileName)
        setExporting(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }
  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetList()
  }

  const menu = (record: MemberData) => {
    return (
      <Menu>
        {canUpdateMember && (
          <Menu.Item
            onClick={() => {
              onClickEdit(record.id)
              setSelectedID(record.id)
              setSelectedCustomer(record)
            }}
          >
            แก้ไขข้อมูล
          </Menu.Item>
        )}
        {canUpdateMemberPoint && (
          <Menu.Item
            onClick={() => {
              setSelectedID(record.id)
              setSelectedCustomer(record)
              setPointAdjustDrawer(true)
            }}
          >
            จัดการคะแนน
          </Menu.Item>
        )}
        {canRedeemPoint && (
          <Menu.Item
            onClick={() => {
              setSelectedID(record.id)
              setSelectedCustomer(record)
              setRewardDrawer(true)
            }}
          >
            แลกของรางวัล
          </Menu.Item>
        )}
        {canSeeHistory && (
          <Menu.Item
            onClick={() => {
              setSelectedID(record.id)
              setSelectedCustomer(record)
              setHistoryDrawer(true)
            }}
          >
            ประวัติคะแนน
          </Menu.Item>
        )}
      </Menu>
    )
  }

  const renderActionButton = (text: string, record: any) => {
    if (!canRedeemPoint && !canSeeHistory && !canUpdateMember && !canUpdateMemberPoint) return
    return (
      <Space size="middle" className="ttr-action-btn">
        <Dropdown key="more" overlay={menu(record)} trigger={['click', 'hover']}>
          <ActionButton text="" icon={<MoreOutlined />} label="" action="edit" />
        </Dropdown>
      </Space>
    )
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'เบอร์โทรศัพท์',
      dataIndex: 'tel',
      key: 'tel',
      sorter: true,
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'full_name',
      key: 'full_name',
      sorter: true,
    },
    // {
    //   title: 'นามสกุล',
    //   dataIndex: 'name',
    //   key: 'name',
    //   sorter: true,
    //   render: renderName,
    // },
    {
      title: 'คะแนนสะสม',
      dataIndex: 'current_point',
      key: 'current_point',
      sorter: true,
      render: (value: any) => `${numberWithComma(value)}`,
      align: 'right',
    },
    {
      title: '',
      dataIndex: 'width',
      key: 'width',
      width: '_0px',
      align: 'right',
    },
    {
      title: 'วันที่อัปเดตข้อมูล',
      key: 'updated_at',
      dataIndex: 'updated_at',
      sorter: true,
      render: (value: any) => formatDateTime(value || ''),
    },
    {
      title: '',
      key: 'action',
      width: '100px',
      render: renderActionButton,
      align: 'center',
    },
  ]

  const DetailDrawer = (
    <BannerDetail
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
      disabled={false}
    />
  )

  const PointHistoryDrawer = (
    <PointHistory id={selectedID} isShow={historydrawer} onClose={() => setHistoryDrawer(false)} />
  )

  const PointRewardDrawer = (
    <PointReward
      id={selectedID}
      isShow={rewardDrawer}
      onClose={() => setRewardDrawer(false)}
      onSuccess={() => {
        setRewardDrawer(false)
        onGetList()
      }}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="top" gutter={[8, 8]}>
        <Col xs={24} md={18}>
          <Row gutter={[8, 8]}>
            <Col xs={24} md={8} className="ttr-filter">
              <SearchInput
                placeholder="ค้นหาชื่อลูกค้า,เบอร์โทรศัพท์"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col>
              <Space size="middle">
                <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
              </Space>
            </Col>
          </Row>
        </Col>
        <Col>
          <Space size="middle" className="ttr-report">
            <PrimaryButton
              text="รายงานสมาชิก"
              icon={<DownloadOutlined />}
              onClick={onExport}
              loading={exporting}
            />
          </Space>
        </Col>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const PointAdjustmentDrawer = (
    <PointAdjustment
      id={selectedID}
      visible={pointAdjustDrawer}
      onCloseDrawer={() => setPointAdjustDrawer(false)}
      onSuccess={() => {
        setPointAdjustDrawer(false)
        onGetList()
      }}
    />
  )

  return (
    <>
      <HomePageLayout
        selected="point-member"
        title="ข้อมูลสมาชิก"
        label=""
        isShowTutorial={showTutorial}
        showTutorial={enableTutorial}
        onClickStart={() => setShowTutorial(true)}
      >
        {FilterContent}
        <LoadingView isShow={exporting} />
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
          onSort={(field: string, order: string) => {
            onSort(field, order)
          }}
          scrollX={800}
          className="ttr-table"
        />
        {DetailDrawer}
        {PointAdjustmentDrawer}
        {PointHistoryDrawer}
        {PointRewardDrawer}
        {enableTutorial && (
          <AppTutorial
            onCloaseTutorial={() => setShowTutorial(false)}
            showTutorial={showTutorial}
            steps={steps}
          />
        )}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectMemberList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

export default connect(mapStateToProps)(PointMember)
